import { render, staticRenderFns } from "./AtualizarCadastro.vue?vue&type=template&id=cea4a580&scoped=true"
import script from "./AtualizarCadastro.vue?vue&type=script&lang=js"
export * from "./AtualizarCadastro.vue?vue&type=script&lang=js"
import style0 from "./AtualizarCadastro.vue?vue&type=style&index=0&id=cea4a580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea4a580",
  null
  
)

export default component.exports